import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import Select from "react-select";
import { setBreadcrumbItems } from "../../store/actions";
import { useParams } from "react-router-dom";
import Spinners from "components/Common/Spinner";
import * as url from "../../helpers/url_helper";
import "flatpickr/dist/themes/material_blue.css";
import { Link } from "react-router-dom";
import { formatDob, getAge } from "helpers/dob_helper";

const UsersDetails = (props) => {
  document.title = "User Details - VUF";
  const { Type, id } = useParams();
  const [locationdata, setlocation] = useState([]);
  const [state, setState] = useState({});
  const [isLoading, setLoading] = useState(false);
  const [profilePicture, setProfilePicture] = useState("");
  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: "User List", link: "#" },
    { title: "User Details", link: "#" },
  ];

  useEffect(() => {
    props.setBreadcrumbItems("User Details", breadcrumbItems);
  });
  useEffect(() => {
    onGetLocationsList();
  }, []);

  function VUFIDFormat(vufId) {
    if (!vufId) return "";
    const groups = [];
    groups.push(vufId.slice(0, 4));
    if (vufId.length > 4) groups.push(vufId.slice(4, 8));
    if (vufId.length > 8) groups.push(vufId.slice(8, 12));
    return groups.filter(Boolean).join("-");
  }

  function onUserInvite(e) {
    setLoading(true);
    let urlPath = "GetUserDetails/" + id;
    fetch(url.AUTH_URL + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      // body: Body,
    })
      .then((response) => response.json())
      .then((responseData) => {
        var typedata = Type.split(/_(.*)/s);
        var urlredirect = typedata[0];
        if (typedata.length > 1) {
          urlredirect = urlredirect + "/" + typedata[1];
        }

        if (responseData.status == true) {
          var user = responseData.response.user;
          setProfilePicture(user.profilePicture);

          var data = {
            address1: user.address1 || "--",
            userId: user._id,
            firstName: user.firstName,
            lastName: user.lastName,
            mobileNo: user.mobileNo,
            vufid: VUFIDFormat(user.vufId),
            email: user.email || "--",
            joinedServices: user.joinedServices.join(", "),
            description: user.description || "--",
            location: user.selectedLocation,
            countryCode: user.countryCode || "--",
            follows: user.follows || "0",
            following: user.following || "0",
            dob: formatDob(user.dob, "YYYY-MM-DD", "--"),
            age: getAge(user.dob, "--"),
            gender: user.gender || "--",
            nickname: user.NickName || "--",
            profession: user.profession || "--",
            oterProfession: user.OtherProfession || "--",
            area: user.area || "--",
            pincode: user.pincode || "--",
            street_address: user.street_address,
            role: user.role,
            designation: user.userDesignation || "--",
            location:
              locationdata.length > 0
                ? locationdata.filter((s) => s.place_id == user.location)[0]
                  .name
                : "--",
            city: user.city || "--",
            district: user.district || "--",
            state: user.state || "--",
            country: user.country || "--",
            village: user.village || "--",
            Type: urlredirect || "--",
            bloodGroup: user.bloodgroup || "--",
            profilePic: `${url.USER_PROFILE_URL}` + user.profilePicture,
          };

          setState(data);

          //this.onGetLocationsList();
        } else {
          alert(
            "Oops! \n\n Something went wrong, Please try again after sometime."
          );
        }
      })
      .catch((error) => { })
      .finally((final) => {
        // this.recaptchaRef.current.reset();
        // return this.setState({ isInvitingUser: false })
        setLoading(false);
      });
  }

  function onGetLocationsList() {
    setLoading(true);
    let urlPath = "DynamicPage/entry-locations/";
    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      // body: Body,
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        if (responseData.status && "data" in responseData) {
          const { data } = responseData;
          const LocationsList = data
            .filter((item) => item.status === "true")
            .map((item) => {
              return {
                ...item,
                Name: item.name,
                id: item.place_id,
                Value: item.name,
              };
            });
          setlocation(LocationsList);
          onUserInvite();
        }
      })
      .catch((error) => { })
      .finally((final) => {
        setLoading(false);
      });
  }

  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <>
          <div className="container" style={{ maxWidth: "100%" }}>
            {/* <div className="row">
              <div className="col-2">
                <Link to={"/" + state.Type} className="btn btn-primary">
                  <span className="menu-text" style={{ color: "white" }}>
                    Back to List
                  </span>
                </Link>
              </div>
            </div> */}
            <div className="row">
              <div className="col-lg-12">
                <div className="card-body row">
                  <h3 className="mb-4 text-left text-primary fw-bold">
                    User Details - {state.firstName} {state.lastName}
                  </h3>
                  <div className="row">
                    <table class="table table-bordered table-striped shadow-sm">
                      <tbody>
                        <tr>
                          <td colspan="4" class="text-center py-4">
                            {state?.profilePic &&
                              profilePicture !== undefined ? (
                              <img
                                src={state.profilePic}
                                alt="Profile"
                                className="rounded-circle me-3"
                                width="100"
                                height="100"
                              />
                            ) : (
                              <div
                                className="rounded-circle bg-secondary text-white d-inline-flex justify-content-center align-items-center shadow-sm"
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  fontSize: "32px",
                                }}
                              >
                                {`${state.firstName?.charAt(0) || ""}${state.lastName?.charAt(0) || ""}`.toUpperCase()}
                              </div>
                            )}
                            {/* <div
                              class="rounded-circle bg-secondary text-white d-inline-flex justify-content-center align-items-center shadow-sm"
                              style={{
                                width: "100px",
                                height: "100px",
                                fontSize: "32px",
                              }}
                            >
                              {`${state.firstName?.charAt(0) || ""}${state.lastName?.charAt(0) || ""}`.toUpperCase()}
                            </div> */}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label>VUF Id:</label> <b>{state.vufid}</b>
                          </td>
                          <td>
                            <label>Name:</label>{" "}
                            <b>
                              {state.firstName} {state.lastName}
                            </b>
                          </td>
                          <td>
                            <label>Mobile Number:</label>
                            <b>
                              {state.countryCode} {state.mobileNo}
                            </b>
                          </td>
                          <td>
                            <label>Email:</label> <b>{state.email}</b>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label>Join Service:</label>{" "}
                            <b>{state.joinedServices}</b>
                          </td>
                          <td>
                            <label>Blood Group:</label>{" "}
                            <b>{state.bloodGroup}</b>
                          </td>
                          <td>
                            <label>Gender:</label> <b>{state.gender}</b>
                          </td>
                          <td>
                            <label>Role:</label> <b>{state.role}</b>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label>Birthdate:</label> <b>{state.dob || "--"}</b>
                          </td>
                          <td colSpan="3">
                            <label>Profession:</label> <b>{state.profession}</b>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="4">
                            <label>Area, City, District, State, Country:</label>
                            <b>
                              {state.area && ` ${state.area},`}
                              {state.city && ` ${state.city},`}
                              {state.district && ` ${state.district},`}
                              {state.state && ` ${state.state},`}
                              {state.country && ` ${state.country}`}
                            </b>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="d-flex">
                  {state.Type === "Users" && (
                    <>
                      <Link
                        to={`/UserDetailsEdit/${state.Type}/${state.userId}`}
                        className="btn btn-outline-primary me-2"
                      >
                        <span class="menu-text">
                          <i class="fa fa-edit me-2"></i>Update User Details
                        </span>
                      </Link>
                      <Link to={"/UserList"} className="btn btn-outline-danger">
                        <span className="menu-text">
                          <i class="fa fa-arrow-left me-2"></i>Back to User List
                        </span>
                      </Link>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(UsersDetails);
